const MEAL_PLAN_MESSAGE_MAX_CHARACTERS_COUNT = 5000;

export { MEAL_PLAN_MESSAGE_MAX_CHARACTERS_COUNT };
